export default __webpack_public_path__ + "static/media/wiring.2557a750.webp";